import type { Template } from "@/types";

export const SQ_03_H3_V0: Template[] = [
    {
        id: "sq-03-h3v0-01",
        name: "SQ 01 - H3V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h3_v0_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 82, y: 220, width: 420, height: 280, rotation: 0, imageRotation: 0 },
            { id: "2", x: 510, y: 220, width: 420, height: 280, rotation: 0, imageRotation: 0 },
            { id: "3", x: 938, y: 220, width: 420, height: 280, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-03-h3v0-02",
        name: "SQ 02 - H3V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h3_v0_02.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 201, width: 473, height: 315, rotation: 0, imageRotation: 0 },
            { id: "2", x: 481, y: 201, width: 473, height: 315, rotation: 0, imageRotation: 0 },
            { id: "3", x: 962, y: 201, width: 472, height: 315, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-03-h3v0-03",
        name: "SQ 03 - H3V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h3_v0_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 165, y: 237, width: 365, height: 246, rotation: 0, imageRotation: 0 },
            { id: "2", x: 538, y: 237, width: 365, height: 246, rotation: 0, imageRotation: 0 },
            { id: "3", x: 911, y: 237, width: 365, height: 246, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-03-h3v0-04",
        name: "SQ 04 - H3V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h3_v0_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 84, y: 176, width: 551, height: 368, rotation: 0, imageRotation: 0 },
            { id: "2", x: 858, y: 64, width: 436, height: 292, rotation: 0, imageRotation: 0 },
            { id: "3", x: 858, y: 364, width: 436, height: 292, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-03-h3v0-05",
        name: "SQ 05 - H3V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h3_v0_05.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 170, y: 116, width: 358, height: 240, rotation: 0, imageRotation: 0 },
            { id: "2", x: 170, y: 364, width: 358, height: 240, rotation: 0, imageRotation: 0 },
            { id: "3", x: 536, y: 116, width: 729, height: 488, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-03-h3v0-06",
        name: "SQ 06 - H3V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h3_v0_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 139, y: 64, width: 436, height: 292, rotation: 0, imageRotation: 0 },
            { id: "2", x: 139, y: 364, width: 436, height: 292, rotation: 0, imageRotation: 0 },
            { id: "3", x: 801, y: 176, width: 551, height: 368, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-03-h3v0-07",
        name: "SQ 07 - H3V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h3_v0_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 67, y: 164, width: 584, height: 391, rotation: 0, imageRotation: 0 },
            { id: "2", x: 764, y: 257, width: 307, height: 206, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1080, y: 257, width: 307, height: 206, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-03-h3v0-08",
        name: "SQ 08 - H3V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h3_v0_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "2", x: 0, y: 75, width: 407, height: 280, rotation: 0, imageRotation: 0 },
            { id: "3", x: 0, y: 363, width: 407, height: 280, rotation: 0, imageRotation: 0 },
            { id: "1", x: 415, y: 75, width: 1018, height: 568, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-03-h3v0-09",
        name: "SQ 09 - H3V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h3_v0_09.png",
        size: [1434, 717],
        style: {},
        slots: [    
            { id: "2", x: 86, y: 81, width: 410, height: 274, rotation: 0, imageRotation: 0 },
            { id: "3", x: 86, y: 363, width: 410, height: 274, rotation: 0, imageRotation: 0 },
            { id: "1", x: 504, y: 81, width: 842, height: 556, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-03-h3v0-10",
        name: "SQ 10 - H3V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h3_v0_10.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 48, y: 258, width: 307, height: 203, rotation: 0, imageRotation: 0 },
            { id: "2", x: 363, y: 258, width: 307, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 782, y: 161, width: 588, height: 398, rotation: 0, imageRotation: 0 },
        ],
    },




];
